import { render, staticRenderFns } from "./estadistico_pps.vue?vue&type=template&id=03c23a04&"
import script from "./estadistico_pps.vue?vue&type=script&lang=ts&"
export * from "./estadistico_pps.vue?vue&type=script&lang=ts&"
import style0 from "./estadistico_pps.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports